import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { get } from 'lodash'
import Typography from 'components/atoms/Typography/Typography'
import BigButton from 'components/molecules/BigButton/BigButton'
import HalfBanner from 'components/molecules/HalfBanner/HalfBanner'
import { userCheckMobileScreen } from 'helpers/tools'

import './BigButtonsWithBanner.scss'

function BigButtonsWithBanner({ data }) {
  const isMobile = userCheckMobileScreen()

  return (
    <Container fluid className="big-buttons-with-banner section-spacing">
      <Container>
        <Typography variant="h2" color="primary" cssClass="mb-3 title-bold-md title-text">
          {get(data, 'title')}
        </Typography>
      </Container>
      <Container>
        <Row className="big-buttons-with-banner__content">
          <Col className="d-flex flex-column" lg={3}>
            {data.items.map(({ entity }) => {
              return (
                <BigButton
                  key={get(entity, 'title', '')}
                  className="mb-3"
                  theme={get(entity, 'theme.entity.classes')}
                  icon={get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
                  url={get(entity, 'link.url.path', '')}
                  title={get(entity, 'title', '')}
                  footer
                />
              )
            })}
          </Col>
          <Col lg={9} className="mb-3">
            <HalfBanner
              imageBackground={isMobile ? get(data, 'media.entity.images.medium.url') : get(data, 'media.entity.images.wide.url')}
              icon={get(data, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default BigButtonsWithBanner
